import React from 'react';
import './style.scss';
import Header from '../header/';
import Tracker from '../../../genesys/tracker';
import { LAYERS } from '../../layers/types';
import { DISPLAY } from '../../main/types';
import * as MainActions from '../../main/actions';

export default class MinimizedFrame extends React.Component {
    constructor(props) {
        super(props);

        this.showAfter =
            props.delays && props.delays.showAfter ? props.delays.showAfter : 0;
        this.hideAfter =
            props.delays && props.delays.hideAfter ? props.delays.hideAfter : 0;
        this.componentTimeout = null;
        this.state = {
            visibility: 'hidden',
            badgeClass: ''
        };
    }

    componentDidMount() {
        if (this.showAfter > 0) {
            this.componentTimeout = setTimeout(
                () => this.show(),
                this.showAfter * 1000
            );
        } else {
            this.show();
        }
    }

    componentWillUnmount() {
        clearTimeout(this.componentTimeout);
    }

    show() {
        this.setState({ visibility: 'visible' });
        if (this.hideAfter > 0) {
            this.componentTimeout = setTimeout(
                () => this.hide(),
                this.hideAfter * 1000
            );
        }
        MainActions.updateMainLayer({
            layer: LAYERS.WIDGET,
            iFrameMode: DISPLAY.STANDARD,
            source: 'minimizedFrame'
        });
    }

    hide() {
        Tracker.timeOutInvite();
        this.props.events.close();
    }

    render() {
        const { type, title, events, badgeCount, children } = this.props;
        switch (type) {
            case 'bar':
                return (
                    <div className={`${this.state.visibility} minimized-view`}>
                        <div
                            className="minimized-view--bar"
                            onClick={events.maximize}
                        >
                            <div className="widget-frame-minimized-bar">
                                <Header
                                    title={title}
                                    events={{ maximize: events.maximize }}
                                />
                            </div>
                        </div>
                    </div>
                );
            case 'icon':
                return (
                    <div className={`${this.state.visibility} minimized-view`}>
                        <div
                            className="minimized-view--icon"
                            onClick={events.maximize}
                        >
                            {badgeCount !== undefined &&
                                badgeCount !== null &&
                                badgeCount !== false && (
                                <div
                                    className={`minimized-view--badge ${this
                                        .props.badgeClass || ''} ${this
                                        .state.badgeClass || ''}`}
                                >
                                    <p>{badgeCount}</p>
                                </div>
                            )}
                            <div
                                className="widget-frame-minimized-icon"
                                title={title}
                            >
                                {children}
                            </div>
                        </div>
                    </div>
                );
        }
    }
}
